import { render, staticRenderFns } from "./BenefitPrakerja.vue?vue&type=template&id=2777d0c3&scoped=true"
import script from "./BenefitPrakerja.vue?vue&type=script&lang=js"
export * from "./BenefitPrakerja.vue?vue&type=script&lang=js"
import style0 from "./css/benefitPrakerja.css?vue&type=style&index=0&id=2777d0c3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2777d0c3",
  null
  
)

export default component.exports